export default import.meta.ROLLUP_FILE_URL_Tk3cKcIR8tYJqQz5l73v2A;